import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { useNavigate} from 'react-router-dom';
import ChangeCluster from '../ChangeCluster';
// import SmallMenuAppBar from './SmallScreenMenuAppBar';
import LargeScreenAppBar from './LargeScreenAppBar';
import LogoBtnLink from './LogoBtnLink';

const pages = ['Snapshots', 'Dex'];

function ResponsiveAppBar() {
  const navigate = useNavigate();

  const onLogoClicked = () => {
    navigate('/')
  }

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <SmallMenuAppBar pages={pages}/>  */}
          <LogoBtnLink onClick={onLogoClicked} />
          <LargeScreenAppBar pages={pages} />
          <ChangeCluster />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
